import { createApp } from 'vue'
import { createPinia } from 'pinia'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import { useAuthStore } from './store/auth'
import { installSessionRecheck } from './auth/session-lifecycle.mjs'
import './assets/styles/main.css'

const app = createApp(App)
const pinia = createPinia()

axios.defaults.xsrfCookieName = 'autosquare_website_csrf'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'

app.use(pinia)
app.use(router)

app.mount('#app')
const stopSessionRecheck = installSessionRecheck({ auth: useAuthStore(pinia), router, changeKey: 'autosquare_website_session_changed' })
if (module.hot) module.hot.dispose(stopSessionRecheck)
